// Logika czatu zgłoszeń bez zależności od Vue — układanie wątku w oś czasu
// (separatory dni, zdarzenia, serie wiadomości jednego autora).

// Kolejne wiadomości tego samego autora w tym odstępie są zlepiane w jedną serię.
export const GROUP_GAP_MS = 5 * 60 * 1000

// Status zgłoszenia (enum TicketStatus w API) → klucz tłumaczenia.
export const STATUS_KEYS = ['TicketStatusNew', 'TicketStatusOngoing', 'TicketStatusWaitingForApprove', 'TicketStatusRejected', 'TicketStatusClosed']

export const TicketStatus = { New: 0, Ongoing: 1, WaitingForApprove: 2, Rejected: 3, Closed: 4 }

// Zdarzenia zapisuje backend po angielsku (TicketsService). W bazie zostają bez zmian,
// bo czyta je też aplikacja mobilna — tłumaczymy znane teksty tutaj.
export const EVENT_KEYS = {
    'Requested to approve.': 'TicketEventRequestedClose',
    'Ticket closed.': 'TicketEventClosed',
    'Confirmed close.': 'TicketEventConfirmedClose',
    'Request to close denied.': 'TicketEventCloseDenied'
}

// Daty przychodzą z API jako UTC bez strefy ("2026-09-24T10:15:00"). Bez dopisania "Z"
// przeglądarka wzięłaby je za czas lokalny i godziny rozjechałyby się o offset.
export function parseUtc(value) {
    if (value instanceof Date) return value
    if (value == null) return null
    const text = String(value)
    return new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(text) ? text : text + 'Z')
}

export function dayKey(date) {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
}

export function initials(name) {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean)
    if (parts.length === 0) return '?'
    return parts.slice(0, 2).map(p => p[0].toUpperCase()).join('')
}

/**
 * Zamienia listę wiadomości na elementy do wyświetlenia:
 *  { type: 'day', key, date }
 *  { type: 'event', key, message }
 *  { type: 'message', key, message, mine, startsGroup, endsGroup }
 * Wiadomości muszą mieć `sentDate` jako Date.
 */
export function buildTimeline(messages, myUserId) {
    const sorted = [...messages].sort((a, b) => a.sentDate - b.sentDate)
    const items = []
    let lastDay = null
    let lastMessageItem = null

    for (const message of sorted) {
        const day = dayKey(message.sentDate)
        if (day !== lastDay) {
            items.push({ type: 'day', key: 'day-' + day, date: message.sentDate })
            lastDay = day
            lastMessageItem = null
        }

        if (message.isEvent) {
            items.push({ type: 'event', key: message.id, message })
            lastMessageItem = null
            continue
        }

        const continuesGroup = lastMessageItem != null
            && lastMessageItem.message.creatorId === message.creatorId
            && message.sentDate - lastMessageItem.message.sentDate <= GROUP_GAP_MS

        if (continuesGroup) {
            lastMessageItem.endsGroup = false
        }

        lastMessageItem = {
            type: 'message',
            key: message.id,
            message,
            mine: message.creatorId === myUserId,
            startsGroup: !continuesGroup,
            endsGroup: true
        }
        items.push(lastMessageItem)
    }

    return items
}

// Klucz tłumaczenia dla nieudanej wysyłki (nowe zgłoszenie albo odpowiedź).
// 413 = za duże żądanie; brak odpowiedzi = zerwane połączenie, co przy dużych zdjęciach
// też zwykle oznacza limit po drodze.
export function sendErrorKey(error, hasPhotos) {
    const status = error && error.response ? error.response.status : null
    if (status === 413) return 'PhotosTooLarge'
    if (status == null && hasPhotos) return 'PhotosUploadFailed'
    return 'SendFailed'
}



// WEBPACK FOOTER //
// ./src/components/Systems/Tickets/ticketChat.js